(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["image-slider-lang"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function initLangSlider(wrapperId) {
    var wrapper  = document.getElementById(wrapperId);
    if (!wrapper) return;

    var track         = wrapper.querySelector('.lang-slider__track');
    var slides        = Array.from(wrapper.querySelectorAll('.lang-slider__slide'));
    var dotsEl        = wrapper.querySelector('.lang-slider__dots');
    var btnPrev       = wrapper.querySelector('.lang-slider__arrow--prev');
    var btnNext       = wrapper.querySelector('.lang-slider__arrow--next');

    if (!slides.length || !track) return;

    var current             = 0;
    var total               = slides.length;
    var autoplay            = wrapper.dataset.autoplay === 'true';
    var autoplayMs          = parseInt(wrapper.dataset.autoplayMs, 10) || 5000;
    var slidesVisible       = parseInt(wrapper.dataset.slidesVisible, 10) || 1;
    var slidesVisibleMobile = parseInt(wrapper.dataset.slidesVisibleMobile, 10) || 1;
    var timer               = null;
    var dots                = [];
    var progBars            = [];

    var touchMoved = false;

    function getSlidesVisible() {
      return window.innerWidth < 750 ? slidesVisibleMobile : slidesVisible;
    }

    /* ── Build dots ── */
    slides.forEach(function (_, i) {
      var dot      = document.createElement('button');
      var progress = document.createElement('span');
      dot.className      = 'lang-slider__dot' + (i === 0 ? ' is-active' : '');
      progress.className = 'lang-slider__dot-progress';
      dot.setAttribute('aria-label', 'Ir a slide ' + (i + 1));
      dot.appendChild(progress);
      dotsEl.appendChild(dot);
      dot.addEventListener('click', function () { pauseAutoplay(); goTo(i); resumeAutoplay(); });
      dots.push(dot);
      progBars.push(progress);
    });

    /* ── Step size ── */
    function getStepPx() {
      var slideW = slides[0].getBoundingClientRect().width;
      var gap    = parseFloat(getComputedStyle(track).gap) || 14;
      return slideW + gap;
    }

    /* ── Max index ── */
    function getMaxIndex() {
      return Math.max(0, total - getSlidesVisible());
    }

    /* ── Navigate ── */
    function goTo(index) {
      var maxIdx = getMaxIndex();
      index = Math.max(0, Math.min(index, maxIdx));

      slides[current].classList.remove('is-active');
      dots[current].classList.remove('is-active');
      resetProgress(current);

      current = index;

      slides[current].classList.add('is-active');
      dots[current].classList.add('is-active');

      track.style.transform = 'translateX(-' + (getStepPx() * current) + 'px)';

      btnPrev.disabled = current === 0;
      btnNext.disabled = current >= maxIdx;
    }

    function goNext() {
      var maxIdx = getMaxIndex();
      goTo(current + 1 > maxIdx ? 0 : current + 1);
    }

    /* ── Progress bar ── */
    function resetProgress(i) {
      var bar = progBars[i];
      bar.style.transition = 'none';
      bar.style.width = '0%';
    }

    function animateProgress() {
      if (!autoplay) return;
      var bar = progBars[current];
      bar.getBoundingClientRect();
      bar.style.transition = 'width ' + autoplayMs + 'ms linear';
      bar.style.width = '100%';
    }

    /* ── Autoplay ── */
    function startAutoplay() {
      if (!autoplay || total <= 1) return;
      animateProgress();
      timer = setTimeout(function () { goNext(); startAutoplay(); }, autoplayMs);
    }

    function pauseAutoplay() {
      clearTimeout(timer);
      timer = null;
      var bar     = progBars[current];
      var computed = getComputedStyle(bar).width;
      var parentW  = bar.parentElement.getBoundingClientRect().width;
      var pct      = parentW > 0 ? (parseFloat(computed) / parentW * 100) : 0;
      bar.style.transition = 'none';
      bar.style.width = pct + '%';
    }

    function resumeAutoplay() {
      if (!autoplay || total <= 1) return;
      resetProgress(current);
      startAutoplay();
    }

    /* ── Arrows ── */
    btnPrev.addEventListener('click', function () { pauseAutoplay(); goTo(current - 1); resumeAutoplay(); });
    btnNext.addEventListener('click', function () { pauseAutoplay(); goTo(current + 1); resumeAutoplay(); });

    /* ── Hover pause ── */
    wrapper.addEventListener('mouseenter', function () { if (autoplay) pauseAutoplay(); });
    wrapper.addEventListener('mouseleave', function () { if (autoplay) resumeAutoplay(); });

    /* ── Touch / swipe ── */
    var touchStartX = 0, touchStartY = 0, dragging = false;

    wrapper.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      dragging = true;
      touchMoved = false;
      if (autoplay) pauseAutoplay();
    }, { passive: true });

    wrapper.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      var dx = Math.abs(e.touches[0].clientX - touchStartX);
      var dy = Math.abs(e.touches[0].clientY - touchStartY);
      if (dx > dy && dx > 8) {
        touchMoved = true;
        e.preventDefault();
      }
    }, { passive: false });

    wrapper.addEventListener('touchend', function (e) {
      if (!dragging) return;
      dragging = false;
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        touchMoved = true;
        goTo(diff > 0 ? current + 1 : current - 1);
      }
      if (autoplay) resumeAutoplay();
    }, { passive: true });

    wrapper.addEventListener('click', function (e) {
      if (touchMoved) {
        e.preventDefault();
        touchMoved = false;
      }
    }, true);

    /* ── Keyboard ── */
    wrapper.setAttribute('tabindex', '0');
    wrapper.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); pauseAutoplay(); goTo(current - 1); resumeAutoplay(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); pauseAutoplay(); goTo(current + 1); resumeAutoplay(); }
    });

    /* ── Resize ── */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var maxIdx = getMaxIndex();
        if (current > maxIdx) current = maxIdx;
        track.style.transition = 'none';
        track.style.transform  = 'translateX(-' + (getStepPx() * current) + 'px)';
        btnPrev.disabled = current === 0;
        btnNext.disabled = current >= maxIdx;
        setTimeout(function () { track.style.transition = ''; }, 50);
      }, 120);
    });

    /* ── Init ── */
    goTo(0);
    startAutoplay();
  }

  function bootstrapAll() {
    document.querySelectorAll('[id^="LangSlider-"]').forEach(function (el) {
      initLangSlider(el.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrapAll);
  } else {
    bootstrapAll();
  }

  document.addEventListener('shopify:block:load', function (e) {
    if (e.target && e.target.id && e.target.id.startsWith('LangSlider-')) {
      initLangSlider(e.target.id);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
